import { render, staticRenderFns } from "./PreviousOrderReceiveInfo.vue?vue&type=template&id=5df19ea2&"
import script from "./PreviousOrderReceiveInfo.vue?vue&type=script&lang=ts&"
export * from "./PreviousOrderReceiveInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports